import { Typography } from "antd";
import type { TFunction } from "i18next";
import TableCreatorName from "./index";
import InlineEditableNote from "@/components/InlineEditableNote";

type CreatorListNameCellProps = {
  item: any;
  handleClick: (item: any) => void;
  t: TFunction;
  onNoteSave?: (orderId: string, note: string) => void;
};

export default function CreatorListNameCell({
  item,
  handleClick,
  t,
  onNoteSave,
}: CreatorListNameCellProps) {
  return (
    <div className={`flex min-w-0 flex-col gap-2 cursor-pointer ${item.__channelRowType === "channel" ? "leading-5" : "leading-[18px] [&_*]:leading-[18px]"}`}>
      <TableCreatorName
        listShowFollowers={true}
        handleClick={handleClick}
        item={item}
      />
      {item?.adsNote?.trim() &&
        (onNoteSave && !item.__channelRowType ? (
          <InlineEditableNote
            key={item.id}
            orderId={item.id}
            note={item.adsNote}
            onSave={onNoteSave}
            variant="compact"
            maxWidth={278}
          />
        ) : (
          <div className="w-full min-w-0 max-w-[278px] overflow-hidden rounded-md bg-[#F5F5F5] px-3 py-1.5 text-xs font-normal leading-[18px] tracking-[-0.12px]">
            <Typography.Text
              className="!block w-full !text-xs !leading-[18px] !text-[#1C1917]"
              ellipsis={{ tooltip: item.adsNote }}
            >
              <span className="text-[#79716B]">
                {t("campaignDetail.creatorTableColumns.notes", {
                  defaultValue: "Notes",
                })}
                {": "}
              </span>{" "}
              {item.adsNote}
            </Typography.Text>
          </div>
        ))}
    </div>
  );
}
